import { render, staticRenderFns } from "./SlideCarousels.vue?vue&type=template&id=c22e6160&scoped=true&"
import script from "./SlideCarousels.vue?vue&type=script&lang=js&"
export * from "./SlideCarousels.vue?vue&type=script&lang=js&"
import style0 from "./SlideCarousels.vue?vue&type=style&index=0&id=c22e6160&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c22e6160",
  null
  
)

export default component.exports